// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import history from '../../../../services/history';
import styles from './styles';
import { Button } from '../../../../components';

class IssueVoucher extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    total: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    total: {},
  };

  onIssueVoucher = () => {
    const { total } = this.props;
    if (total.redeemValue !== 0) {
      history.push('/account/vouchers/issue');
    }
  }

  render() {
    const { classes } = this.props;
    const textTopRegular = 'You can continue to add items to your cart or issue the voucher';

    return (
      <div className={classes.mainContainer}>
        <div className={classes.textContainer}>
          <span className={classes.textTop}>{textTopRegular}</span>
        </div>
        <Button
          text={'issue voucher'}
          style={classes.buttonStyle}
          onPress={this.onIssueVoucher}
        />
      </div>
    );
  }
}

export default withStyles(styles)(IssueVoucher);
